import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class JwtService {
  storage: Storage = localStorage
  tokenKey = 'authToken'
  refreshTokenKey = 'refreshToken'

  constructor() {}

  getToken(): string {
    return this.storage.getItem(this.tokenKey)
  }

  getRefreshToken(): string {
    return this.storage.getItem(this.refreshTokenKey)
  }

  saveToken(token: string) {
    this.storage.setItem(this.tokenKey, token)
  }

  saveRefreshToken(refreshToken: string) {
    this.storage.setItem(this.refreshTokenKey, refreshToken)
  }

  destroyToken() {
    this.storage.removeItem(this.tokenKey)
  }

  destroyRefreshToken() {
    this.storage.removeItem(this.refreshTokenKey)
  }

  setStorage(storage: 'local' | 'session') {
    if (storage === 'local') {
      this.storage = localStorage
    } else {
      this.storage = sessionStorage
    }
  }
}
